routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.response', {
      url: "response/{auth}",
      template: `<response sh-ctrl="shCtrl"></response>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/response/response.config.js
 **/